/*
 * POOM — drobne zachowania UI.
 *  - [data-pk-clamp]: opis kolekcji zwiniety do kilku linii; przycisk "Czytaj wiecej" tylko,
 *    gdy tekst faktycznie jest dluzszy (inaczej przycisk zostaje ukryty).
 *  - "+N" przy swatchach w kartach (snippets/variant-swatches.liquid): klik odslania wszystkie kolory.
 *  - slajdy wariantow w kartach produktow (snippets/card-gallery.liquid): ukryte slajdy nie maja <img>,
 *    sa puste (adres w data-pk-img + szerokosci w data-pk-w); .product-media z <img> dokladamy, gdy slajd zostaje odslaniety
 *    (product-card.js zdejmuje [hidden] po wyborze swatcha, slideshow.js ustawia [reveal] przy podgladzie).
 */
(() => {
  const initClamp = (root = document) => {
    root.querySelectorAll('[data-pk-clamp]:not([data-pk-clamp-ready])').forEach((desc) => {
      desc.dataset.pkClampReady = '1';
      const btn = desc.nextElementSibling?.matches('.pk-collection-head__more') ? desc.nextElementSibling : null;
      if (!btn) return;
      desc.classList.add('is-clamped');
      if (desc.scrollHeight <= desc.clientHeight + 8) {
        desc.classList.remove('is-clamped');
        return;
      }
      btn.hidden = false;
      btn.addEventListener('click', () => {
        const open = desc.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Zwiń' : 'Czytaj więcej';
      });
    });
  };

  const startClamp = () => {
    if (!document.querySelector('[data-pk-clamp]')) return; // tylko strony kolekcji z opisem
    initClamp();
    // filtry kolekcji przerysowuja sekcje (morph) — podepnij ponownie nowy opis
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; initClamp(); });
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  };

  /* --- leniwe zdjecia slajdow wariantow --- */
  const hydrateSlide = (slide) => {
    const d = slide.dataset;
    if (!d.pkImg) return;
    const base = d.pkImg;
    const sep = base.includes('?') ? '&' : '?';
    const widths = (d.pkW || '').split(',').filter(Boolean);
    const [w, h] = (d.pkWh || '').split('x');
    const wrap = document.createElement('div');
    wrap.className = 'product-media';
    wrap.style.setProperty('--ratio', d.pkRatio || '1');
    wrap.dataset.mediaId = slide.getAttribute('slide-id') || '';
    const img = new Image();
    img.className = 'product-media__image';
    if (w) img.width = Number(w);
    if (h) img.height = Number(h);
    img.alt = d.pkAlt || '';
    img.loading = 'lazy'; // product-card.js odslania slajd wybranego wariantu juz przy starcie — pod ekranem ma czekac
    // srcset + sizes przed src, zeby przegladarka nie pobierala dwa razy
    if (widths.length) img.srcset = widths.map((x) => `${base}${sep}width=${x} ${x}w`).join(', ');
    img.sizes = slide.closest('.card-gallery')?.dataset.pkSizes || '100vw';
    img.src = widths.length ? `${base}${sep}width=${widths[widths.length - 1]}` : base;
    wrap.appendChild(img);
    slide.appendChild(wrap);
    delete d.pkImg;
  };
  const slideRevealed = (slide) => !slide.hasAttribute('hidden') || slide.hasAttribute('reveal') || slide.getAttribute('aria-hidden') === 'false';
  const startSlides = () => {
    new MutationObserver((records) => {
      for (const r of records) {
        const t = r.target;
        if (!(t instanceof Element) || t.tagName !== 'SLIDESHOW-SLIDE' || !t.dataset.pkImg || !slideRevealed(t)) continue;
        hydrateSlide(t);
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['hidden', 'reveal', 'aria-hidden'], subtree: true });
    // zapas: slajd widoczny od razu, a mimo to bez obrazu (nie powinno sie zdarzyc)
    document.querySelectorAll('slideshow-slide[data-pk-img]:not([hidden])').forEach(hydrateSlide);
  };

  /* --- "+N" przy swatchach w kartach: pokaz wszystkie (lista statyczna, bez <overflow-list>) --- */
  const startSwatches = () => {
    document.addEventListener('click', (e) => {
      const btn = e.target instanceof Element ? e.target.closest('.pk-swatches .hidden-swatches__count') : null;
      if (!btn) return;
      e.preventDefault();
      btn.closest('.pk-swatches')?.classList.add('pk-swatches--all');
    });
  };

  const start = () => { startSlides(); startSwatches(); startClamp(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
